import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/sites';
import { ResultState } from '@rootCommon/types/common';
import { SiteSelector } from '@rootCommon/types/site';

type Action = ActionType<typeof actions>;
export type SiteSelectorState = ResultState<SiteSelector[] | null>;

const initState: SiteSelectorState = {
  data: null,
  loading: false,
  error: null,
};

export const sitesSelectorReducer = (state = initState, action: Action): SiteSelectorState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchSitesSelector.request):
      return { ...state, loading: true, error: null };
    case getType(actions.fetchSitesSelector.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchSitesSelector.failure):
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default sitesSelectorReducer;
